export const LOCAL_STORAGE_KEYS = {
  DEFAULT_THEME: 'defaultTheme',
  RESET_SESSION_IDLE_TIMER: 'resetSessionIdleTimer',
  THEME: 'theme',
  COLUMNS_ORDER_AND_SIZE: 'columnsOrderAndSize',
  COST_CENTERS: 'costCenters',
};

export const SESSION_STORAGE_KEYS = {
  ACTIVE_COST_CENTERS: 'activeCostCenters',
  COST_ALLOCATION_SORT: 'costAllocationSort'
};
